// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"396":"302470ab","513":"78a04a94"}[chunkId] + ".chunk.js";
};